/**
 * Generic table export — Excel (.xlsx) and PDF.
 * Driven by a simple { headers, rows } shape so any table can use it.
 *
 * Both formats go through `richExport`, so every grid in the app gets the same
 * branded header band, coloured header row, banded rows and typed number
 * columns without the calling page configuring anything.
 */
import { exportRichExcel, exportRichPdf, type CellValue } from './richExport';

export interface TableExport {
  fileName: string;
  headers: string[];
  rows: CellValue[][];
  title?: string;
  subtitle?: string;
  /** Extra "Label: value" pairs for the line under the title. */
  meta?: Record<string, CellValue>;
}

const titleOf = (t: TableExport) => t.title || t.fileName.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function exportToExcel({ fileName, headers, rows, title, subtitle, meta }: TableExport) {
  return exportRichExcel({
    fileName,
    title: titleOf({ fileName, headers, rows, title }),
    subtitle,
    meta,
    columns: headers,
    rows,
    sheetName: 'Data',
  });
}

export function exportToPdf({ fileName, headers, rows, title, subtitle, meta }: TableExport) {
  return exportRichPdf({
    fileName,
    title: titleOf({ fileName, headers, rows, title }),
    subtitle,
    meta,
    columns: headers,
    rows,
  });
}
